<template>
  <div class="providers-list-bottom">
    <span class="providers-list-bottom-text"> {{ text }}</span>
    <span class="providers-list-bottom-amount" @click="handleAmountChange">
      <span style="margin-right: 10px;">
        {{ $n(amount, "currency", locale.value) }}

        <div class="term-label">
          {{ termLabel }}
        </div>
      </span>
      <img
        src="@/assets/icons/edit_pencil.svg"
        alt="Change amount"
        @click="handleAmountChange"
      />
    </span>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: "BottomBar",
  props: {
    text: {
      type: String,
      required: true,
    },
    amount: {
      type: Number,
      required: true,
    },
    currencySymbol: {
      type: String,
      required: true,
    },
    termLabel: {
      type: String,
      required: true,
    },
  },
  emits: ["change-payment-amount"],
  setup() {
    const { t, n, locale } = useI18n();
    return {
      t,
      n,
      locale,
    };
  },
  methods: {
    handleAmountChange() {
      this.$emit("change-payment-amount");
    },
  },
});
</script>

<style scoped>
.providers-list-bottom {
  display: flex;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  border-radius: 10px 10px 0px 0px;
  border: 1px solid var(--Gray-elements-Segmenter-lines);
  background: var(--Gray-elements-Background-BLOCKS);
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 22px;
  padding-right: 22px;
  align-items: center;
  justify-content: center;
}

.providers-list-bottom-text {
  flex: 1 0 0;
  text-align: left;
  color: var(--Typography-Text-2);
  font-feature-settings: "clig" off, "liga" off;
  /* Seccion heading - Bottons */
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 150% */
  margin-left: 10px;
  align-items: center;
}

.providers-list-bottom-amount {
  text-align: right;
  color: var(--Primary-Green-1);
  font-feature-settings: "clig" off, "liga" off;
  font-family: "Inter", sans-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  align-items: center;
  display: flex;
}

.term-label {
  color: var(--text-grey);
  text-align: right;
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Inter", sans-serif;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 17px; /* 154.545% */
}
</style>
